import router from 'frontend/router';

import ProfileMain from './comp/ProfileMain.vue';
import ProfileHome from './comp/ProfileHome.vue';
import AddressForm from './comp/AddressForm.vue';
import PaymentMethodForm from './comp/PaymentMethodForm.vue';
import Orders from './comp/Orders.vue';
import OrderView from './comp/OrderView.vue';

router.addRoutes([
	{
		name: 'profile-main',
		path: '/profile',
		component: ProfileMain,
		children: [
			{
				name: 'profile-home',
				path: '',
				component: ProfileHome,
				meta: { title: 'Manage My Profile' }
			},
			{
				name: 'profile-address-form',
				path: 'address/:id',
				props: true,
				component: AddressForm,
				meta: { title: 'Update Address' },
			},
			{
				name: 'profile-payment-method-form',
				path: 'payment_method/:id',
				props: true,
				component: PaymentMethodForm,
				meta: { title: 'Update Payment Method' },
			},
			{
				name: 'profile-orders',
				path: 'orders',
				props: true,
				component: Orders,
				meta: { title: 'Order History' },
			},
			{
				name: 'profile-order-view',
				path: 'order/:id',
				props: true,
				component: OrderView,
				meta: { title: 'View Order' },
			},
		]
	}
]);